import { DataGrid } from "@material-ui/data-grid";
import React from "react";
import { useQuery } from "react-query";
import { Col, Jumbotron, Row } from "reactstrap";
import API from "../../api/API";
import columns from "./columns";
import useDocumentTitle from "../../hooks/useDocumentTitle";

const styles = { gridDiv: { height: 700, width: "100%" } };
const Profile = ({ ...props }) => {
  useDocumentTitle("Profile");
  const { data: seshData } = useQuery("seshesUnpaged", () =>
    API.seshes.getAll()
  );
  const formatSeshes = (sesh) => ({
    ...sesh,
    swell1Height: sesh.swells[0]?.height,
    swell1Dir: sesh.swells[0]?.direction,
    swell1Period: sesh.swells[0]?.period,
    swell2Height: sesh.swells[1]?.height,
    swell2Dir: sesh.swells[1]?.direction,
    swell2Period: sesh.swells[1]?.period,
    swell3Height: sesh.swells[2]?.height,
    swell3Dir: sesh.swells[2]?.direction,
    swell3Period: sesh.swells[2]?.period,
    spot: sesh.spot.name,
  });
  const rows = seshData?.seshes?.map(formatSeshes);
  return (
    <Jumbotron>
      <Row>
        <Col>
          <h1>Profile</h1>
          <p>More coming soon...</p>
        </Col>
      </Row>
      <h3>All Seshes ({rows?.length})</h3>
      <Row>
        <Col>
          <div style={styles.gridDiv}>
            <DataGrid rows={rows || []} columns={columns} />
          </div>
        </Col>
      </Row>
    </Jumbotron>
  );
};

export default Profile;
